import type { SegmentMst } from '@libs/domain';
import { MstMaintenanceTmpl } from '@libs/templates/mst';
import type { PageProps } from '@ps-smart-cp/ppfw-client';
import { withRerender } from '@ps-smart-cp/ppfw-client';
import { genSegmentMstColumns, highOrderAdditionalInfo } from './components';
import { useSegmentMstSettings } from './hooks';
import { SegmentMstListSearch } from './models';
import { doExport, listRequest, remove } from './repositories';
import { createSegmentMstItemName, createSegmentMstListSearchFieldConfig } from './services';

function PageComponent({
  segmentMstKey,
  ...restProps
}: PageProps & Pick<SegmentMst['schema'], 'segmentMstKey'>) {
  const segmentMstSettings = useSegmentMstSettings();

  return (
    <MstMaintenanceTmpl
      mstName={createSegmentMstItemName(segmentMstKey, segmentMstSettings)}
      columns={genSegmentMstColumns(segmentMstKey)}
      items={createSegmentMstListSearchFieldConfig(segmentMstKey, segmentMstSettings)}
      listRequestFunction={listRequest(segmentMstKey)()}
      initMst={SegmentMstListSearch.init}
      exportFunction={doExport(segmentMstKey)()}
      deleteFunction={remove(segmentMstKey)()}
      {...restProps}
    >
      {highOrderAdditionalInfo(segmentMstKey)}
    </MstMaintenanceTmpl>
  );
}

const Maintenance = withRerender(PageComponent, 'Maintenance');

export { Maintenance };
